var map = {
	"./Announcement/index.svelte": [
		71,
		0,
		5
	],
	"./TextFitter/index.svelte": [
		69,
		0,
		6
	],
	"./TypeWriter/index.svelte": [
		70,
		0,
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 54;
module.exports = webpackAsyncContext;